import {AuthenticatedEntityApiDto} from "../../api/model/rest";
import {Option} from "ts-option";
import User from "./User";
import IndividualContact from "../contact/IndividualContact";
import {getUser} from "../../store/view/user";
import {getIndividualContact} from "../../store/view/contact";

export default class AuthenticatedEntity {
	/**
	 * User details for event user identifier.
	 */
	userDetails: Option<User>;
	/**
	 * Individual contact for event user identifier.
	 */
	individualContact: Option<IndividualContact>;

	/**
	 * @param {string} id Entity uuid.
	 * @param {AuthenticatedEntityTypeEnum} type Entity type.
	 */
	constructor(public readonly id: string, public readonly type: AuthenticatedEntityTypeEnum) {
		switch (this.type) {
			case AuthenticatedEntityTypeEnum.User:
				this.userDetails = getUser(this.id);
				break;
			case AuthenticatedEntityTypeEnum.Customer:
				this.individualContact = getIndividualContact(this.id);
				break;
		}
	}

	public static fromJson(json: AuthenticatedEntityApiDto): AuthenticatedEntity {
		return new AuthenticatedEntity(json.id, AuthenticatedEntity.typeFromString(json.type));
	}

	public static typeFromString(type: string) {
		switch (type) {
			case AuthenticatedEntityTypeEnum.User:
				return AuthenticatedEntityTypeEnum.User;
			case AuthenticatedEntityTypeEnum.SDK:
				return AuthenticatedEntityTypeEnum.SDK;
			case AuthenticatedEntityTypeEnum.Customer:
				return AuthenticatedEntityTypeEnum.Customer;
			case AuthenticatedEntityTypeEnum.Api:
				return AuthenticatedEntityTypeEnum.Api;
			case AuthenticatedEntityTypeEnum.System:
				return AuthenticatedEntityTypeEnum.System;
			default:
				return AuthenticatedEntityTypeEnum.User;
		}
	}

	/**
	 * Get display name.
	 */
	getDisplayName(): string {
		if (this.type == AuthenticatedEntityTypeEnum.User) {
			return this.userDetails.map(u => u.getDisplayName()).getOrElse(() => this.id);
		}
		else if (this.type == AuthenticatedEntityTypeEnum.Customer) {
			return this.individualContact.map(ic => ic.data.displayName()).getOrElse(() => this.id);
		}
		else if (this.type == AuthenticatedEntityTypeEnum.SDK || this.type == AuthenticatedEntityTypeEnum.Api) {
			return "Internal service"
		}
		else if (this.type == AuthenticatedEntityTypeEnum.System) {
			return "System"
		}
		else {
			return this.id;
		}
	}
}

export enum AuthenticatedEntityTypeEnum {
	User = "USER",
	SDK = "SDK",
	Customer = "CUSTOMER",
	Api = "API",
	System = "SYSTEM"
}